import React, { Component } from 'react';
import { flowRight as compose } from 'lodash';
import { injectIntl } from 'react-intl';
import messages from '../../../locale/messages';
import ManageNotificationsForm from '../../../components/SiteAdmin/ManageNotificationsForm';


export class ManageNotifications extends Component {

  render() {
    const { formatMessage } = this.props.intl;
    const { siteName } = this.props;

    let initialValues = {
      to: "all",
      messageType: "pushNotification",
      title: siteName
    };

    return (
      <div>
        <h1 className='siteAdminPrimaryHeading'>{formatMessage(messages.manageNotifications)}</h1>
        <ManageNotificationsForm initialValues={initialValues} />
      </div>
    )
  }

}

export default compose(
  injectIntl
)(ManageNotifications)
